import { render, staticRenderFns } from "./KosiwonInformationFragments.vue?vue&type=template&id=11f7e64b&scoped=true&"
import script from "./KosiwonInformationFragments.vue?vue&type=script&lang=js&"
export * from "./KosiwonInformationFragments.vue?vue&type=script&lang=js&"
import style0 from "./KosiwonInformationFragments.vue?vue&type=style&index=0&id=11f7e64b&scoped=true&lang=less&"
import style1 from "./KosiwonInformationFragments.vue?vue&type=style&index=1&id=11f7e64b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7e64b",
  null
  
)

export default component.exports